import { X } from 'lucide-react'
import { usePlayer } from '@/audio/store'
import { Button, IconButton } from '@/components/ui'
import { useQueueFeedback } from './queueGestureActions'
import { useIncognito } from '@/lib/incognito'
import { cn } from '@/lib/cn'

export function useCurrentQueueNotice() {
  const notice = useQueueFeedback((state) => state.notice)
  const session = usePlayer((state) => state.session)
  const privacy = useIncognito((state) => state.active)
  return notice?.session === session && notice.privacy === privacy ? notice : null
}

/** Lives inside the dialog focus scope, unlike the application's outside toast portal. */
export function QueueFeedback({ className }: { className?: string }) {
  const notice = useCurrentQueueNotice()
  if (!notice) return null
  return <div className={cn('flex items-center gap-2 rounded-lg border border-border bg-surface-raised p-2 shadow-lg', className)} data-gesture-ignore>
    <p role="status" className="min-w-0 flex-1 text-sm text-text">{notice.title}</p>
    {notice.action ? <Button size="sm" variant="secondary" onClick={() => { useQueueFeedback.setState({ notice: null }); notice.action?.() }}>{notice.label}</Button> : null}
    <IconButton aria-label="Dismiss queue notification" size="sm" onClick={() => useQueueFeedback.setState({ notice: null })}><X className="h-4 w-4" aria-hidden="true" /></IconButton>
  </div>
}
